import { API } from "./utils"

export const vod = {
  vodFilesList: (params = null) => API.get("/vod/files/", { params }),
}
